export default __webpack_public_path__ + "static/media/dog.07118312.png";